<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item
                label="线下领取牌匾的比赛名称"
            >
              <div v-if="formData.extra_saiqu.length > 0" style="cursor: pointer" @click="showSaiquPicker = true">
                {{ formData.extra_saiqu[0].name }}
              </div>
              <div v-else style="cursor: pointer" @click="showSaiquPicker = true">点击选择领取的比赛名称 <i
                  class="el-icon-arrow-right"></i></div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="申报年度"
                prop="year"
                :rules="[
                { required: true, message: '请选择申报年度' },
              ]"
            >
              <el-date-picker
                  v-model="formData.year"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="点击选择申报年度">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="type">
              <el-radio-group v-model="formData.type">
                <el-radio :label="1">全国校园大课间啦啦操推广示范单位</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="省市区"
                prop="area"
                :rules="[
                {
                  required: true,
                  message: '请选择省市区',
                },
              ]"
            >
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="单位名称"
                prop="danwei"
                :rules="[
                { required: true, message: '单位名称不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.danwei"
                  type="text"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="详细地址"
                prop="address"
                :rules="[
                { required: true, message: '请输入详细地址', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.address"
                  type="text"
                  placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="全校人数"
                prop="renshu"
                :rules="[
                { required: true, message: '人数不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.renshu"
                  type="text"
                  placeholder="请输入人数"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>先进个人（教师或校长信息）</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="个人姓名"
                prop="jiaoshi_name"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.jiaoshi_name"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
              <div class="form-label-desc mt10">限一人</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="活动照片" prop="huodongpic">
              <PicUploader :fileList="formData.huodongpic" :limit="5"></PicUploader>
<!--              <div class="form-label-desc">上传一张队伍照片(横版)</div>-->
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>联系人信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="个人姓名"
                prop="name"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.name"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="phone"
                :rules="[
                { required: true, validator: validator.phone, message: '请输入正确的手机号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  type="text"
                  placeholder="请输入手机"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交报名
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
      <SaiquPicker
          :show="showSaiquPicker"
          :limit="1"
          :value="formData.extra_saiqu"
          @onChange="onSaiquChange"
          @onClose="showSaiquPicker=false"
          :defaultValue="formData.extra_saiqu"
          @onConfirm="onSaiquConfirm"
      ></SaiquPicker>

  </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button, Dialog
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'DakejianApplySimple',
  components: {
    PicUploader, LoginDialog,SaiquPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      showSaiquPicker:false,
      showDate: false,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',

      minDate: new Date( ),
      formData: {
        id: 0,
        year: '',
        type: 1,
        address: '',
        extra_saiqu: [],
        huodongpic: [],
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = '大课间申报'

    that.areaList = area;
    that.formData.id = this.$route.query.id;
    that.getUserDetail();
    that.getAreaOptions();
//            if(that.formData.id){
//             this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },
    getUserDetail() {
      let that = this;
      this.$api.get('/api/user/userPage', {}, (res) => {
        console.log(res)
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        } else {
          Toast(res.msg)
        }
      })
    },

    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      // this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
      this.formData.year =  `${date.getFullYear()}-${date.getMonth() + 1}`
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName])
      that.$refs[formName].validate((valid) => {
        if (valid) {
          for (let field in that.formData) {

            if (!this.formData.area) {
              that.$message.info('请选择地区');
              return
            }

            if (!this.formData.huodongpic.length) {
              that.$message.info('请上传活动图片');
              return
            }
          }
          that.saveLoading = true;
          that.formData.stationid = that.formData.extra_saiqu.length ? that.formData.extra_saiqu[0].id :0
          that.$api.post('/api/cdakejian/applySimple', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('提交成功');
            setTimeout(() => {
              // rbLink({
              //   name: "CDakejianApplySuccess",
              //   query: {
              //     id: res.data.id
              //   }
              // }, 'replace')

              rbLink({
                name: "",
              }, 'back')
            }, 200)
          }, (res) => {

            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {}
                    },
                    "replace"
                );
                return false;
              } else {
                // Toast(res.msg);
                this.loginShow = true;
              }
            }
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }

        if (!this.formData.huodongpic.length) {
          Toast.fail('请上传活动图片');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/cdakejian/applySimple', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('提交成功');
        setTimeout(() => {
          // rbLink({
          //   name: "CDakejianApplySuccess",
          //   query: {
          //     id: res.data.id
          //   }
          // }, 'replace')

          rbLink({
            name: "",
          }, 'back')
        }, 200)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// DakejianApplySimple.vue?ee57091c